import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion } from '../../../atoms/Accordion';
import { LoginBlockFooter } from './LoginBlockFooter';
export const LoginBlock = props => {
    return (_jsxs("div", Object.assign({ className: "login-block" }, { children: [_jsx(Accordion, { children: props.children }), props.hasFooter ? _jsx(LoginBlockFooter, { variant: props.variant }) : null] })));
};
